<template>
    <div
        v-if="visible"
        class="checkout-processing-overlay"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        aria-busy="true">
        <div class="checkout-processing-overlay-content">
            <loading-animation></loading-animation>
            <p class="checkout-processing-overlay-message">
                {{ $translate("Ceres::Template.checkoutProcessingOrder") }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "checkout-processing-overlay",

    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },

    mounted()
    {
        document.body.appendChild(this.$el);
    },

    beforeDestroy()
    {
        if (this.$el.parentNode === document.body)
        {
            document.body.removeChild(this.$el);
        }
    }
};
</script>
